import axios from 'axios';

export default ()=>{
    return axios.create({
        baseURL: process.env.REACT_APP_LOGIN_API_URL
        // baseURL: "https://hj69fdm43e.execute-api.eu-west-1.amazonaws.com/prod"
    })
}